import { type FC, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import ChevronIcon from '@assets/img/icons/chevron-2.svg?react';
import cn from 'classnames';

import { ModalContext } from '@/components/Modals/Modal/config';
import { StringMain, StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import tgem3dWithCashIconPng from '/img/icons/tgem-3d-and-cash.png';
import tgem3dWithCashIconWebp from '/img/icons/tgem-3d-and-cash.webp';
import starsPng from '/img/patterns/stars.png';
import starsWebp from '/img/patterns/stars.webp';

const EarnCashAndCoinButton: FC = () => {
  const { t } = useTranslation();
  const { openModal } = useContext(ModalContext);

  return (
    <div
      onClick={() =>
        openModal({ renderKind: 'referralLevelsTable', props: undefined })
      }
      className={css.earnCashAndButtton}
    >
      <div className="w-full h-full flex gap-2 items-center relative z-[2]">
        <div className="h-full aspect-square shrink-0">
          <Picture
            className="size-full"
            img={tgem3dWithCashIconPng}
            webp={tgem3dWithCashIconWebp}
            alt="cash and T-GEM"
          />
        </div>
        <div className="flex-1 min-w-0 h-full flex flex-col justify-between py-[1px]">
          <StringMain weight="bold" className={cn('leading-1.2', css.green)}>
            <Trans
              i18nKey={'Earn up to <1>190B</1> Cash and'}
              components={{ 1: <span /> }}
            />
          </StringMain>
          <div className="flex items-baseline gap-1">
            <StringMain
              weight="bold"
              className={cn(css.blue, 'text-nowrap shrink-0 inline-block')}
            >
              <Trans
                i18nKey={'<1>2K+</1> T-GEM'}
                components={{ 1: <span /> }}
              />
            </StringMain>{' '}
            <StringSmall className="whitespace-nowrap text-nowrap overflow-hidden text-ellipsis">
              {t('from partner’s progress')}
            </StringSmall>
          </div>
        </div>
        <ChevronIcon className="-scale-x-[1] text-white/40 w-6 h-6 shrink-0" />
      </div>
      <span className={css.leftCircleEffect}></span>
      <span className={css.rightCircleEffect}></span>
      <Picture
        className={css.starsPattern}
        img={starsPng}
        webp={starsWebp}
        alt="stars"
      />
    </div>
  );
};

export { EarnCashAndCoinButton };
